<template>
  <div class="move-user-machine-group">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('moveUserMachineGroup.title')"
      :visible.sync="dialogMoveUserMachineGroup"
      width="860px"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <!-- <el-select
          v-model="moveUserMachine.uId"
          :no-data-text="$t('common.noData')"
          :no-match-text="$t('common.noData')"
          filterable
          :placeholder="$t('moveUserMachineGroup.select')"
          :loading="loading"
          remote
          :remote-method="remoteMethod"
        >
          <el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id">
            <span style="float: left">{{ item.userName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nickName }}</span>
          </el-option>
        </el-select> -->
        <div style="width: 94%; margin: 0 auto">
          <Wselect
            :hasAll="false"
            :multiple="false"
            styleSize="medium"
            v-model="moveUserMachine.uId"
            :options="userList"
            :loading="loading"
            @remoteMethod="remoteMethod"
            :placeholder="$t('user.MoveUserMachineGroup.725312-0')"
          ></Wselect>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-transfer
            style="text-align: left; display: inline-block"
            v-model="moveUserMachine.equipmentIds"
            filterable
            :filter-method="handlerInit"
            :filter-placeholder="$t('user.MoveUserMachineGroup.725312-1')"
            :props="{
              key: 'id',
              label: 'equipmentName'
            }"
            :titles="[$t('moveUserMachineGroup.titL'), $t('moveUserMachineGroup.titR')]"
            :button-texts="[$t('moveUserMachineGroup.btL'), $t('moveUserMachineGroup.btR')]"
            @change="handleChange"
            :data="machineList"
          >
            <span slot-scope="{ option }">{{ option.equipmentNo }} - {{ option.equipmentName }}</span>
          </el-transfer>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :loading="loadingForm" @click="submitForm('userMachineGroup')">{{
          $t("moveUserMachineGroup.move")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Wselect from "_c/system/user/Wselect";
  export default {
    name: "MoveUserMachineGroup",
    components: {
      Wselect
    },
    props: {
      dialogMoveUserMachineGroup: Boolean,
      teamId: String
    },
    data() {
      return {
        userList: [],
        machineList: [],
        moveUserMachine: {
          equipmentIds: [],
          uId: "",
          teamId: "",
          userName: ""
        },
        loadingForm: false,
        loading: false,
        page: {
          pageIndex: 1,
          pageSize: 10
        }
      };
    },
    methods: {
      remoteMethod(query, page) {
        this.page.pageIndex = page;
        this.moveUserMachine.userName = query;
        this.init();
      },
      init: async function () {
        this.loading = true;
        // 获取选项数据，后端需支持 page  size  name搜索
        const res = await this.$api.request(this.$url.User.giveUser, this.$method.get, {
          teamId: this.teamId,
          userName: this.moveUserMachine.userName,
          ...this.page
        });
        this.userList = res.data.records;
        this.loading = false;
      },

      // 解决穿梭框搜索不出东西bug
      filterMethod(query, item) {
        console.log(query, 111, item, 999);
        if (!query || item.id.indexOf(query) != -1 || item.equipmentNo.indexOf(query) != -1) {
          return item;
        }
      },
      closeDialog() {
        this.cancel("");
      },
      openDialog() {
        this.moveUserMachine.teamId = this.teamId;
        this.$api
          .request(this.$url.UserMachineGroup.choosePage, this.$method.get, {
            teamId: this.teamId
          })
          .then(res => {
            if (res.code === 0) {
              this.machineList = res.data.records;
            }
          });
      },
      submitForm() {
        if (this.moveUserMachine.uId === "") {
          this.$message.warning(this.$t("moveUserMachineGroup.pMoveU"));
          return false;
        }
        if (this.moveUserMachine.equipmentIds.length <= 0) {
          this.$message.warning(this.$t("moveUserMachineGroup.pMoveM"));
          return false;
        }
        this.loadingForm = true;
        this.$api
          .request(this.$url.UserMachineGroup.moveUserMachine, this.$method.put, this.moveUserMachine)
          .then(res => {
            console.log(res);
            let obj = JSON.parse(res.data);
            if (res.code === 0) {
              this.cancel();
              this.$notify({
                title: this.$t("common.tip"),
                message: this.$t('user.MoveUserMachineGroup.725312-2', [obj.success,obj.error,res.msg]),
                type: "success"
              });
            }
            this.loadingForm = false;
          })
          .catch(() => {
            this.loadingForm = false;
          });
      },
      cancel() {
        this.$emit("moveUserMachineGroupCancel", false);
      },
      handleChange(value, direction, movedKeys) {
        console.log(value, direction, movedKeys);
      }
    }
  };
</script>

<style lang="scss">
  .transfer-footer {
    margin-left: 20px;
    padding: 6px 5px;
  }
  .el-transfer-panel {
    width: 300px !important;
  }
  .el-transfer__buttons {
    width: 100px;
    .el-button {
      width: 100%;
    }
    .el-button:last-child {
      margin-left: 0;
    }
  }
  .el-transfer-panel__filter {
    input {
      border-radius: 4px !important;
    }
  }
  .el-transfer-panel__body {
    height: 360px !important;
  }
  .el-transfer-panel__list.is-filterable {
    height: 312px;
  }
</style>
